/**
 * Extract YouTube video ID from various YouTube URL formats
 */
export function getYouTubeVideoId(url: string): string | undefined {
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&?/\s]+)/,
    /^([a-zA-Z0-9_-]{11})$/,
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match) {
      return match[1];
    }
  }
  return undefined;
}

/**
 * Get video thumbnail URL and watch URL from embed URL
 */
export function getVideoInfo(
  embedUrl: string
): { thumbnailUrl: string; watchUrl: string } | undefined {
  // YouTube
  const videoId = getYouTubeVideoId(embedUrl);
  if (videoId) {
    return {
      thumbnailUrl: `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`,
      watchUrl: `https://www.youtube.com/watch?v=${videoId}`,
    };
  }

  // Vimeo
  const vimeoMatch = embedUrl.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vimeoMatch) {
    const vimeoId = vimeoMatch[1];
    return {
      thumbnailUrl: `https://vumbnail.com/${vimeoId}.jpg`,
      watchUrl: `https://vimeo.com/${vimeoId}`,
    };
  }

  return undefined;
}
